// extracted by mini-css-extract-plugin
export default {"faq":"Faq_faq__WrKqj","faqList":"Faq_faqList__Ot4Ke","faqItem":"Faq_faqItem__9JZh1"};